// TODO: Make Animated.OverlayPanelContainer.js reusable to be used here
import React from 'react';
import { useTransition, useSpring, animated } from 'react-spring';
import { TRANSITION_DECELERATE, TRANSITION_ACCELERATE } from '@nokia-csf-uxr/freeform-design-tokens/tokens/transition';
import { SPEED_NORMAL } from '@nokia-csf-uxr/freeform-design-tokens/tokens/speed';
import { getContext, getEasing, getDuration, isAnimationDisabled } from 'common';

const enterBezier = getEasing(TRANSITION_DECELERATE);
const leaveBezier = getEasing(TRANSITION_ACCELERATE);

const SPRING_ANIMATION = (isOpen, openedWidth, immediate) => ({
  width: openedWidth,
  config: {
    duration: getDuration(SPEED_NORMAL),
    easing: isOpen ? leaveBezier : enterBezier
  },
  immediate
});

export default ({ children, visible, style, variant, disableAnimation: propsdisableAnimation, ...otherProps }) => getContext(({ RTL, disableAnimation }) => {
  const { width } = style;
  const transitions = useTransition(visible, null, RTL ? {
    initial: {
      marginRight: 0,
    },
    from: { marginRight: -1 * width },
    enter: { marginRight: 0 },
    leave: { marginRight: -1 * width },
    config: { duration: getDuration(SPEED_NORMAL), easing: visible ? leaveBezier : enterBezier },
    immediate: isAnimationDisabled(propsdisableAnimation, disableAnimation),
  } : {
    initial: { marginLeft: 0 },
    from: { marginLeft: -1 * width },
    enter: { marginLeft: 0 },
    leave: { marginLeft: -1 * width },
    config: { duration: getDuration(SPEED_NORMAL), easing: visible ? leaveBezier : enterBezier },
    immediate: isAnimationDisabled(propsdisableAnimation, disableAnimation),
  });

  const expandedStyle = useSpring(SPRING_ANIMATION(!visible, width, isAnimationDisabled(propsdisableAnimation, disableAnimation)));
  const compactAnimation = (
    <animated.div
      style={{
        ...style,
        ...expandedStyle,
        visibility: expandedStyle.width && expandedStyle.width.interpolate(o => (o === 0 ? 'hidden' : 'visible')),
      }}
      {...otherProps}
    >
      {children}
    </animated.div>
  );
  const otherAnimation = (
    transitions.map(({ item, key, props }) =>
      item && (
      <animated.div key={key} style={{ ...props, ...style }} {...otherProps}>
        {children}
      </animated.div>
      ))
  );
  return variant === 'compact' ? compactAnimation : otherAnimation;
});